import { useClinic } from '~contexts/clinic-context'
import { formatDate } from '../helpers'
import { DateFormat } from '../shared-types'
import { Country } from '../constants/countries'
import { ClinicPreviewFieldsFragment } from '~graphql/generated/graphql'

export function useFormatDate({
    clinicOverride,
}: { clinicOverride?: ClinicPreviewFieldsFragment } = {}) {
    const { clinic, clinicGroup } = useClinic()

    const timeZone =
        clinicOverride?.time_zone ||
        clinic?.time_zone ||
        clinicGroup?.clinic_group_clinics?.at(0)?.clinic?.time_zone ||
        undefined

    const country = (clinicOverride?.address?.country ||
        clinic?.address?.country ||
        clinicGroup?.clinic_group_clinics?.at(0)?.clinic?.address?.country ||
        null) as Country | null

    return {
        formatDate: (
            date: Date | number,
            format: DateFormat = DateFormat.Date,
        ) => {
            return formatDate(date, format, timeZone, country)
        },
    }
}
